/* TLY gold article cards (Claude, 2026-10-23): article summaries end on a whole word with an ellipsis inside 2 lines.
   The CSS 2-line clamp stays as the fallback; this only shortens text that would overflow. Full text kept in data-tly-full. */
(function () {
  if (window.tlyGoldCards) return;
  window.tlyGoldCards = true;

  function fit(p) {
    var full = p.getAttribute('data-tly-full');
    if (full === null) {
      full = p.textContent.replace(/\s+/g, ' ').trim();
      p.setAttribute('data-tly-full', full);
    }
    p.classList.add('tly-measure');
    var cs = getComputedStyle(p);
    var lh = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.5;
    var max = lh * 2 + 2;
    p.textContent = full;
    if (p.getBoundingClientRect().height <= max) {
      p.classList.remove('tly-measure');
      return;
    }
    var words = full.split(' ');
    var clip = function (n) { return words.slice(0, n).join(' ').replace(/[\s,;:.!?\-–—]+$/, '') + '…'; };
    var lo = 0, hi = words.length - 1;
    while (lo < hi) {
      var mid = (lo + hi + 1) >> 1;
      p.textContent = clip(mid);
      if (p.getBoundingClientRect().height <= max) lo = mid; else hi = mid - 1;
    }
    p.textContent = clip(Math.max(lo, 1));
    p.classList.remove('tly-measure');
  }

  function run() {
    document.querySelectorAll('.tly-gold-card .article-card__excerpt').forEach(fit);
  }

  var lastWidth = window.innerWidth, timer;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  document.addEventListener('shopify:section:load', run);
})();
